import { render, staticRenderFns } from "./vehicle-details-card.vue?vue&type=template&id=543ef752&scoped=true"
import script from "./vehicle-details-card.vue?vue&type=script&lang=js"
export * from "./vehicle-details-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ef752",
  null
  
)

export default component.exports